import { render, staticRenderFns } from "./add.vue?vue&type=template&id=8bbad1d8&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\jenkinsworkspace\\Aigo.B2CAdmin.Publish\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bbad1d8')) {
      api.createRecord('8bbad1d8', component.options)
    } else {
      api.reload('8bbad1d8', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=8bbad1d8&", function () {
      api.rerender('8bbad1d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/information/add.vue"
export default component.exports